/* SST option picker (snippets/sst-options.liquid).
   Tiles, rows and add-ons write to the theme's hidden .single-option-selector
   selects and fire `change`, so theme.js keeps owning variant id, price, URL
   and the Add To Cart state. This file only keeps the picker in sync:
   selected state, sold-out values, row prices, add-on deltas and the SAVE chip. */
(function () {
  'use strict';

  function money(cents) {
    var t = window.theme;
    if (t && t.Currency && t.Currency.formatMoney) {
      return t.Currency.formatMoney(cents, t.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function init(root) {
    if (root.dataset.sstReady) return;
    root.dataset.sstReady = '1';

    var dataEl = root.querySelector('[data-sst-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = root.closest('form');
    var sectionId = root.getAttribute('data-section-id');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sst-opt]'));

    function selectFor(index) {
      var scope = form || document;
      var sel = scope.querySelector('.single-option-selector-' + sectionId + '[data-option-index="' + index + '"]');
      if (!sel) sel = scope.querySelectorAll('.single-option-selector')[index];
      return sel;
    }

    // Clicks are shown right away; the theme's own (slow) variant handlers
    // run after the browser has painted, and rapid clicks collapse into one.
    var pending = {};
    var flushQueued = false;

    function current() {
      return groups.map(function (g) {
        var idx = g.getAttribute('data-sst-opt');
        if (Object.prototype.hasOwnProperty.call(pending, idx)) return pending[idx];
        var sel = selectFor(idx);
        return sel ? sel.value : null;
      });
    }

    function flush() {
      flushQueued = false;
      var todo = pending;
      pending = {};
      Object.keys(todo).forEach(function (idx) {
        var sel = selectFor(idx);
        if (!sel || sel.value === todo[idx]) return;
        sel.value = todo[idx];
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      sync();
    }

    function paintPrice(v) {
      if (!v || v.compare > v.price) return; // sale layout: let theme.js swap it
      var card = root.closest('.sst-buy-card') || document;
      Array.prototype.forEach.call(card.querySelectorAll('[data-regular-price]'), function (el) {
        el.textContent = money(v.price);
      });
    }

    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function choose(index, value) {
      if (current()[groups.findIndex(function (g) { return g.getAttribute('data-sst-opt') === String(index); })] === value) return;
      pending[index] = value;
      sync();
      paintPrice(find(current()));
      if (flushQueued) return;
      flushQueued = true;
      requestAnimationFrame(function () { setTimeout(function () { if (flushQueued) flush(); }, 0); });
      setTimeout(function () { if (flushQueued) flush(); }, 120); // rAF can stall in background tabs
    }

    function updateSave(v) {
      var card = root.closest('.sst-buy-card') || document;
      var chip = card.querySelector('[data-sst-save]');
      if (!chip || !v) return;
      if (v.compare > v.price) {
        chip.textContent = 'SAVE ' + money(v.compare - v.price);
        chip.hidden = false;
      } else {
        chip.hidden = true;
      }
    }

    function sync() {
      var cur = current();
      var curV = find(cur);

      groups.forEach(function (g, gi) {
        var kind = g.getAttribute('data-kind');

        if (kind === 'addon') {
          var btn = g.querySelector('[data-sst-addon]');
          var yes = btn.getAttribute('data-yes');
          var no = btn.getAttribute('data-no');
          var on = cur[gi] === yes;
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
          var alt = cur.slice(); alt[gi] = on ? no : yes;
          var altV = find(alt);
          var delta = btn.querySelector('[data-sst-delta]');
          btn.disabled = !altV || (!on && !altV.available);
          if (delta) {
            if (!altV) delta.textContent = '';
            else if (!on && !altV.available) delta.textContent = 'Sold out';
            else if (curV) {
              var d = on ? (curV.price - altV.price) : (altV.price - curV.price);
              delta.textContent = d > 0 ? '+' + money(d) : (d < 0 ? '-' + money(-d) : '');
            }
          }
          return;
        }

        Array.prototype.forEach.call(g.querySelectorAll('.sst-choice'), function (c) {
          var value = c.getAttribute('data-value');
          var opts = cur.slice(); opts[gi] = value;
          var v = find(opts);
          var selected = cur[gi] === value;
          var soldOut = !v || !v.available;
          c.setAttribute('aria-checked', selected ? 'true' : 'false');
          c.classList.toggle('is-sold-out', soldOut && !selected);
          c.setAttribute('aria-disabled', soldOut && !selected ? 'true' : 'false');
          var price = c.querySelector('[data-sst-price]');
          if (price) price.textContent = v ? money(v.price) : '';
          var sub = c.querySelector('[data-sst-sub]');
          if (sub) {
            var def = sub.getAttribute('data-default') || '';
            sub.textContent = soldOut && !selected ? 'Sold out' : def;
          }
        });
      });

      updateSave(curV);
    }

    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-sst-q]');
      if (q) {
        var note = document.getElementById(q.getAttribute('aria-controls'));
        var open = q.getAttribute('aria-expanded') !== 'true';
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (note) note.hidden = !open;
        return;
      }

      var choice = e.target.closest('.sst-choice');
      if (choice) {
        if (choice.getAttribute('aria-disabled') === 'true') return;
        var g = choice.closest('[data-sst-opt]');
        choose(g.getAttribute('data-sst-opt'), choice.getAttribute('data-value'));
        return;
      }

      var addon = e.target.closest('[data-sst-addon]');
      if (addon && !addon.disabled) {
        var ga = addon.closest('[data-sst-opt]');
        var on = addon.getAttribute('aria-checked') === 'true';
        choose(ga.getAttribute('data-sst-opt'), on ? addon.getAttribute('data-no') : addon.getAttribute('data-yes'));
      }
    });

    // Arrow keys move within a radio group.
    root.addEventListener('keydown', function (e) {
      var choice = e.target.closest('.sst-choice');
      if (!choice) return;
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (!keys[e.key]) return;
      var list = Array.prototype.slice.call(choice.parentNode.querySelectorAll('.sst-choice:not([aria-disabled="true"])'));
      var i = list.indexOf(choice);
      var next = list[(i + keys[e.key] + list.length) % list.length];
      if (next) { e.preventDefault(); next.focus(); next.click(); }
    });

    // Anything else that changes the selects (URL ?variant=, other scripts) keeps us in sync.
    if (form) {
      form.addEventListener('change', function (e) {
        if (!flushQueued && e.target.classList && e.target.classList.contains('single-option-selector')) sync();
      });
    }

    sync();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sst-options]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
